import React from 'react';
import { Outlet } from 'react-router-dom';
import PageComponent from '../components/PageComponent';

const PageLayout = () => (
  <PageComponent>
    <Outlet />
  </PageComponent>
);

export default PageLayout;
